/** @type {{ countryName: string, countryShortCode: string, regions: { name: string, shortCode: string }[] } []} */
const COUNTRY_REGION_DATA = require("country-region-data");
const COUNTRY = Object.freeze( COUNTRY_REGION_DATA.find( region => region.countryShortCode === "DE" ) );
const REGIONS = Object.freeze( (COUNTRY ? COUNTRY.regions : []).map( region => ({ value: region.shortCode, label: region.name }) ) );

export default class Util {

    static get REGIONS() { return REGIONS; }

    /**
     * Converts a region code like "BE" to the name eg. "Berlin"
     * @param {string} code The region code
     */
    static getRegionNameFromCode( code ) {
        const region = REGIONS.find( region => region.value === code );
        return region ? region.label : "keine Angabe";
    }

    /**
     * @param {number} ts The unix timestamp to convert
     */
    static timestampToDateString( ts ) {
        const date = new Date( ts*1000 );
        return [[date.getDate(), 2], [date.getMonth()+1, 2], [date.getFullYear(), 4]].map( args => Util.fillWithZeroes( ...args ) ).join(".");
    }

    /**
     * Converts a given number i to a string with length n and fills it up with zeroes
     * @param {number} i The number to convert
     * @param {number} n The resulting (minimum) string length. May be longer if number i exceeds this.
     */
    static fillWithZeroes( i, n ) {
        var res = i.toString();
        while( res.length < n ) res = "0" + res;
        return res;
    }

}